import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const SearchIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g stroke="currentColor" strokeWidth="2">
      <circle cx="10" cy="10" r="8" />
      <path d="M16 16L24 24" />
    </g>
  </svg>,
  'search-icon'
);
